<template>
  <b-card body-class="p-0" header-class="border-0">
    <template v-slot:header>
      <b-row align-v="center">
        <b-col>
          <h3 class="mb-0">Solar Roof 2 Project Forcast</h3>
        </b-col>
        <b-col class="text-right">
          <b>Total : 50 Site & 13.9 MWp</b>
          <br>
        </b-col>
      </b-row>
    </template>


    <el-table
      class="table-responsive table"
      :data="tableData"
      header-row-class-name="thead-light">

      <el-table-column label="Month" min-width="140px" prop="month">
      </el-table-column>

      <el-table-column label="Site" min-width="120px" prop="site">

      </el-table-column>

      <el-table-column label="MWp" min-width="110px" prop="capacity">
        <template v-slot="{row}">
          <div class="d-flex align-items-center">
            <span class="mr-2">{{row.capacity}}</span>
            <!-- <base-progress :type="row.progressType" :value="row.progress" /> -->
          </div>
        </template>
      </el-table-column>

    </el-table>
  </b-card>
</template>
<script>
  import { BaseProgress } from '@/components';
  import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown} from 'element-ui'
  export default {
    name: 'solar-roof-2',
    components: {
      BaseProgress,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
    },
    data() {
      return {
        dates:
        {
          start_date: '2021-05-21',
          end_date: '2021-08-20',
        },
        tableData: [
          {
            month: 'August',
            site: '31',
            capacity: 11.7,
            progressType: 'gradient-danger',
          },
          {
            month: 'September',
            site: '11',
            capacity: 0.8,
            progressType: 'gradient-danger',
          },
          {
            month: 'December',
            site: '8',
            capacity: 1.4,
            progressType: 'gradient-danger',
          },
        ]
      }
    }

  }
</script>
<style>
</style>
